import { ProblemDetails, ValidationProblemDetails } from '../client';

type Error = {
  errors?: ValidationProblemDetails | ProblemDetails;
};

export function unwrapValidationError(error: Error | undefined) {
  if (!error?.errors || !('errors' in error.errors)) return [];

  return (error.errors.errors as ValidationProblemDetails['errors'])?.['Validation'] || [];
}

export function unwrapNotFoundError(error: Error | undefined) {
  if (!error?.errors || !('errors' in error.errors)) return [];

  return (error.errors.errors as ValidationProblemDetails['errors'])?.['NotFound'] || [];
}
